import { render, staticRenderFns } from "./DvTooltip.vue?vue&type=template&id=40f1e682&scoped=true&lang=pug"
import script from "./DvTooltip.vue?vue&type=script&lang=js"
export * from "./DvTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1e682",
  null
  
)

export default component.exports